export const extCoreConfig = [];
